import { Dimensions, DIMENSION_TEMPLATE } from "./dimensions";
import { DtacBase, REF_TEMPLATE } from "./dtac-base";
import { HandlingInstructions, HANDLING_INSTRUCTIONS_TEMPLATE } from "./handling-instructions";
import { OtherIdentifier } from "./other-identifier";
import { SecurityDeclaration, SECURITY_DECLARATION_TEMPLATE } from "./security-declaration";
import { ShipmentRef } from "./shipment";
import { TransportMovement, TRANSPORT_MOVEMENT_TEMPLATE } from "./transport-movement";
import { Uld, ULD_TEMPLATE } from "./uld";
import { Value, VALUE_TEMPLATE } from "./value";
import { VolumetricWeight, VOLUMETRIC_WEIGHT_TEMPLATE } from "./volumetric-weight";



export interface Piece extends DtacBase {
  dimensions: Dimensions;
  grossWeight: Value;
  shipment: ShipmentRef;
  goodsDescription: string;
  transportMovements: TransportMovement[];
  securityDeclaration: SecurityDeclaration;
  handlingInstructions: HandlingInstructions[];
  uldReference: Uld;
  volumetricWeight: VolumetricWeight;
  otherIdentifiers: OtherIdentifier[];
};


export const EMPTY_PIECE: Piece = {
  '@id': '',
  '@type': '',
  dimensions: DIMENSION_TEMPLATE,
  grossWeight: VALUE_TEMPLATE,
  goodsDescription: '',
  shipment: REF_TEMPLATE,
  transportMovements: [TRANSPORT_MOVEMENT_TEMPLATE],
  securityDeclaration: SECURITY_DECLARATION_TEMPLATE,
  handlingInstructions: [HANDLING_INSTRUCTIONS_TEMPLATE],
  uldReference: ULD_TEMPLATE,
  volumetricWeight: VOLUMETRIC_WEIGHT_TEMPLATE,
  otherIdentifiers: []
};
